module.exports = __webpack_public_path__ + "static/media/ups.036f80c0.svg";